import { Injectable } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { SelfServeAppState } from '@rci/self-serve-fido/state/app.state.model';
import * as fromActions from './auth.actions';
import * as fromSelectors from './auth.selectors';
import { getLatestValue } from '@rogers/self-serve-utils';

@Injectable({ providedIn: 'root' })
export class AuthStateFacade {
  constructor(private readonly store: Store<SelfServeAppState>) {}

  get guid(): string {
    return getLatestValue<string>(this.store.pipe(select(fromSelectors.guid)));
  }

  loadAuthState() {
    this.store.dispatch(fromActions.loadAuthState());
  }

  resetAuthState() {
    this.store.dispatch(fromActions.resetAuthState());
  }
}
